import { Avatar, Box, Button, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import LabelTxt from '../../../components/LabelTxt'
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { getSingleComServ } from '../../../services/com-service';
import { getFileUrl } from '../../../services/s3-service';
import { isNotEmpty } from '../../../utils/format';
import { useAuthContext } from '../../../context/AuthContext';
import { useEffect } from 'react';
import { customAlert } from '../../../components/notify';
import { useNavigate } from 'react-router-dom';
import route from '../../../utils/Routes';
import BlurImg from '../../../components/BlurImg';
import ScrollBox from '../../../components/ScrollBox';
import constants from '../../../utils/Constants';
import CtrlLabelTxtFieldInfo from '../../../components/CtrlLabelTxtFieldInfo';

function ComInfo({ comId }) {
    const navigate = useNavigate();
    const theme = useTheme();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const { isLoading, isError, error, data: comData } = useQuery([QueryKey.singleCom, comId], () => getSingleComServ(comId), {
        enabled: isNotEmpty(comId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })
    const { isLoading: isComImgLoading, data: comImgUrl } = useQuery([QueryKey.img, comData?.logo],
        () => getFileUrl({ fileKey: comData?.logo }), {
        enabled: isNotEmpty(comData?.logo),
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    const typoHeadStyle = { width: 100, borderColor: "rgb(0,0,0,0.1)", fontWeight: 500, fontSize: 13, mt: 2, color: "rgb(0,0,0,1)", display: "inline-block", }
    const typostyle = { fontSize: 12, mt: 2, color: "rgba(0,0,0, 0.9)", ml: 2, display: "inline-block", }
    const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        setLoadingScreen(isComImgLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComImgLoading]);

    function handleEditComClick() {
        navigate(route.aEditCom, { state: { comId } });
    };



    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        comData && <ScrollBox><Stack sx={{ pt: 3, pl: 3, position: "relative" }}>
            <Stack direction={"row"} >
                <Stack width={"40%"} >
                    <Stack direction={"row"} alignItems={"center"} >
                        <Avatar sx={{ height: 40, width: 40, mr: 1 }} >
                            <BlurImg imgUrl={comImgUrl} alt={"profile"} />
                        </Avatar>
                        <Typography sx={{ fontSize: 15, fontWeight: 500 }}>{comData?.comName}</Typography>
                    </Stack>
                    <Stack ml={3}>
                        <LabelTxt typoname={'License No'} typodetail={comData?.licNo} overflow={60} namestyle={typoHeadStyle} detailstyle={typostyle} />
                        <LabelTxt typoname={'Tax No'} typodetail={comData?.taxNo} overflow={60} namestyle={typoHeadStyle} detailstyle={typostyle} />
                        {/* <LabelTxt typoname={'Address'} typodetail={comData?.address} overflow={60} namestyle={typoHeadStyle} detailstyle={typostyle} /> */}
                        <LabelTxt typoname={'Contact No'} typodetail={comData?.contactNo} overflow={60} namestyle={typoHeadStyle} detailstyle={typostyle} />
                        <LabelTxt typoname={'Email ID'} typodetail={comData?.email} overflow={60} namestyle={typoHeadStyle} detailstyle={typostyle} />
                        <LabelTxt typoname={'Website Link'} typodetail={comData?.webAddr} overflow={60} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    </Stack>

                </Stack>
                <Stack sx={{ width: "30%", height: "90%" }}>
                    <Stack direction={'row'} alignItems='center' mt={-1}>
                        <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>Addresses</Typography>
                    </Stack>
                    <Box sx={{ backgroundColor: "#ffff", borderRadius: 1.4, border: 1, height: 400, borderColor: '#E3E3E3', width: "100%", }}>
                        <ScrollBox height={"100%"} >
                            {(comData?.addrArr || []).map((e, index) => (
                                <Stack key={index} sx={{
                                    borderRadius: 1.4, gap: 2, mb: 0.5, px: 1, py: 0.5,
                                    backgroundColor: "rgba(162, 214, 249, 0.2)", width: "100%", position: "relative"
                                }}>
                                    <CtrlLabelTxtFieldInfo name="addr" title={`Address: ${index + 1}`} placeholder={"Enter company address....."} {...txtFieldSx} width={"100%"} multiline={true}
                                        height={90} rows={5} value={e.addr} readOnly={true} />
                                </Stack>
                            ))}
                        </ScrollBox>
                    </Box>

                </Stack>
            </Stack>
            {ctxtUser?.userType === constants.admin && <Button variant='outlined' onClick={handleEditComClick} sx={{
                fontSize: 13, ml: 5, position: "absolute", right: 20, top: 10,
                color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
            }}>
                Edit Info</Button>}
        </Stack>
        </ScrollBox>
    )
}

export default ComInfo
